import { usePortalMetadataQuery } from '@/lib/queries';
import { isNotFound } from '@tanstack/react-router';
import type { HTMLAttributes } from 'react';

export function DivWithPrimaryColorVariable(props: HTMLAttributes<HTMLDivElement>) {
	const metadata = usePortalMetadataQuery();

	if (isNotFound(metadata)) return <div {...props} />;

	const primaryColor = metadata.color === '#ffffff' || metadata.color === '#fdfdfd' ? '#000000' : metadata.color;

	return <div {...props} style={{ '--primary': primaryColor, '--ring': primaryColor } as React.CSSProperties} />;
}
